import styles from './style.module.scss';

export type TabsType = {
  tabs: {
    label: string;
    key: string;
  }[];
  value?: string;
  onChange?: (value: string) => void;
  style?: React.CSSProperties;
};

export const Tabs = (props: TabsType) => {
  const { tabs, value, onChange, style } = props;

  return (
    <div className={styles.sSearchRightTabs} style={style}>
      {tabs.map((item) => {
        return (
          <div
            key={item.key}
            className={styles.sSearchRightTabsItem}
            onClick={() => onChange?.(item.key)}
          >
            <span
              className={
                item.key === value
                  ? styles.sSearchRightTabsItemTaActive
                  : styles.sSearchRightTabsItemTaNormal
              }
            >
              {item.label}
            </span>
            {item.key === value ? (
              <span className={styles.sSearchRightTabsItemDotNormal} />
            ) : null}
          </div>
        );
      })}
    </div>
  );
};
